module.exports = __webpack_public_path__ + "static/media/IMG_0283.fa11cd7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/IMG_0283.jpg
// module id = 493
// module chunks = 0